import React from 'react';
import { Box, Skeleton, Card, CardContent, Grid } from '@mui/material';

const ProjectDetailSkeleton: React.FC = () => {
  return (
    <Box>
      {/* KPI cards skeleton */}
      <Grid container spacing={3} mb={3}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Grid item xs={6} sm={6} md={2.4} key={i}>
            <Card>
              <CardContent sx={{ p: 2 }}>
                <Skeleton variant="text" width="50%" height={16} />
                <Skeleton variant="text" width="60%" height={36} sx={{ mt: 1 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Chart placeholder */}
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="40%" height={28} />
              <Skeleton variant="rectangular" width="100%" height={250} sx={{ mt: 2, borderRadius: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="50%" height={28} />
              <Skeleton variant="rectangular" width="100%" height={250} sx={{ mt: 2, borderRadius: 1 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Job rows skeleton */}
      <Card>
        <CardContent>
          <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
          {Array.from({ length: 4 }).map((_, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Skeleton variant="text" width={30} />
              <Skeleton variant="text" width={120} />
              <Skeleton variant="rounded" width={80} height={24} />
              <Skeleton variant="text" width={50} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProjectDetailSkeleton;
